import { View, TouchableOpacity, Platform, Text } from "react-native";
import React from "react";

import GlobalStyles from "../../globalStyles/globalStyles";
import AuthIcons from "../../assets/Icons/AuthIcons";
import dimensions from "../../globalStyles/dimensions";

interface BottomViewProps {
  enableTitle?: boolean;
  onPress?: any;
  disableBtn: boolean;
  bottomTitle?: string;
  bottomTitleIcon?: any;
  style?: any;
}

const BottomView: React.FC<BottomViewProps> = ({
  enableTitle = true,
  onPress,
  disableBtn,
  bottomTitle,
  bottomTitleIcon = true,
  style
}) => {

  return (
    <View
      style={[{
        flexDirection: "row",
        paddingHorizontal: dimensions.paddingHorizontal,
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
      }, style]}
    >
      <View style={{width: '80%'}}> 
        {enableTitle && (
          <View style={{flexDirection: 'row', alignItems: 'center', gap: 10}}>
            {bottomTitleIcon && <AuthIcons.AuthLock />}
            <Text numberOfLines={2} style={[GlobalStyles.captionText, {flexWrap: 'wrap', width: '80%',
            fontFamily: 'InterMedium', letterSpacing: -0.16,  color: "#ACABAB",
          }]}>
              {bottomTitle}
            </Text>
          </View>
        )}
      </View>
      {disableBtn ? (
        <TouchableOpacity
          onPress={() => (disableBtn ? onPress && onPress() : null)}
          // style={{alignSelf: 'flex-end'}}
        >
          <AuthIcons.AuthArrow />
        </TouchableOpacity>
      ) : (
        <View
          style={{
            opacity: 0.2,
            // alignSelf: 'flex-end'
          }}
        >
          <AuthIcons.AuthArrow />
        </View>
      )}
    </View>
  );
};

export default BottomView;
